import React from "react";
import { TFunction } from "i18next";
import { CheckIcon } from "@aureskonnect/react-ui";

import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";
import { EtkColumn } from "@components/Common/EtkTable";

import { CustomIconsWrapper } from "./CustomIconsWrapper";

type Params = {
    t: TFunction;
    isFidelityArchived: boolean;
    selectedRows: FidelityRow[];
    setSelectedRows: React.Dispatch<React.SetStateAction<FidelityRow[]>>;
    setIsConsult: React.Dispatch<React.SetStateAction<boolean>>;
    setIsAddFidelityClicked: React.Dispatch<React.SetStateAction<boolean>>;
    setFidelity: React.Dispatch<React.SetStateAction<FidelityRow | undefined>>;
    setDataIsUpdated: React.Dispatch<React.SetStateAction<number | boolean>>;
};

export function useEtkColumns({
    t,
    isFidelityArchived,
    selectedRows,
    setSelectedRows,
    setIsConsult,
    setIsAddFidelityClicked,
    setFidelity,
    setDataIsUpdated,
}: Params): EtkColumn[] {
    return React.useMemo<EtkColumn[]>(
        () => [
            {
                index: 99,
                header: t("Actions"),
                cell: (e) => (
                    <CustomIconsWrapper
                        e={e}
                        setDataIsUpdated={setDataIsUpdated}
                        setSelectedRows={setSelectedRows}
                        isFidelityArchived={isFidelityArchived}
                        selectedRows={selectedRows}
                        setIsConsult={setIsConsult}
                        setIsAddFidelityClicked={setIsAddFidelityClicked}
                        setFidelity={setFidelity}
                    />
                ),
                disableFilter: false,
            },
            {
                index: 5,
                header: t("Centralized loyalty"),
                cell: (e) => (
                    <span>
                        {e.selectedRow[t("State")] === true && (
                            <CheckIcon
                                className="mt-1 ml-1 cmn_chk_selectButton"
                                height={30}
                                width={30}
                            />
                        )}
                    </span>
                ),
                filterable: true,
            },
            {
                index: 4,
                header: t("Adresse"),
                cell: (e) => (
                    <CustomColumnDisplay text={e.selectedRow.Adresse} />
                ),
                filterable: true,
                filterName: "Adresse",
            },
        ],
        // Why: deps track visible state (tab + selection + i18n). Non-memoized
        // setters from upstream are excluded to keep the column-memo stable.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [t, isFidelityArchived, selectedRows]
    );
}
